/**
 * DeleteDialog — Confirmation dialog for permanently deleting an inactive resident.
 */

const DeleteDialog = ({
  residentName,
  onClose, onConfirm, saving,
}) => {
  return (
    <div className="pp-dialog-backdrop" onClick={onClose}>
      <div className="pp-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="pp-dialog__header">
          <h2 className="pp-dialog__title">Delete Resident</h2>
          <button className="dp-drawer__close" onClick={onClose}>&#x2715;</button>
        </div>
        <div className="pp-dialog__body">
          <p style={{ margin: 0, lineHeight: 1.6, color: 'var(--color-danger, #c53030)' }}>
            Are you sure you want to permanently delete <strong>{residentName}</strong>?
          </p>
          <p style={{ margin: 'var(--space-2) 0 0', color: 'var(--color-text-muted)', fontSize: 'var(--font-size-sm)' }}>
            This action cannot be undone. All data associated with this resident will be removed.
          </p>
        </div>
        <div className="pp-dialog__footer">
          <button className="dp-btn dp-btn--cancel" onClick={onClose} disabled={saving}>
            Cancel
          </button>
          <button className="dp-btn dp-btn--danger" onClick={onConfirm} disabled={saving}>
            {saving ? 'Deleting\u2026' : 'Delete Permanently'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteDialog;
